/* src/app/modules/portal/components/advanced-search-table/advanced-search-table.component.scss */
:host {
  display: flex;
  flex-grow: 1;
  max-width: 100%;
  min-width: calc(100% - 352px);
}
.empty-search-content {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
}
.advanced-search-content {
  margin: 1rem;
  display: flex;
  flex-direction: column;
  width: calc(100% - 2rem);
}
.advanced-search-content sh-spinner {
  margin: auto;
}
.table-wrapper {
  overflow-x: auto;
  height: 100%;
  contain: layout style;
  position: relative;
}
table {
  width: 100%;
  height: 100%;
  display: contents;
}
.mat-mdc-header-cell {
  border-bottom: var(--table-cell-stroke-width, 1px) solid var(--ui-1-opacity-400, rgba(0, 0, 0, 0.4));
  z-index: 2;
  top: 0;
  position: sticky;
  background: var(--surface-primary, #fff);
}
.mat-mdc-header-cell:hover .custom-sort-icon:not(.asc):not(.desc) .up,
.mat-mdc-header-cell:hover .custom-sort-icon:not(.asc):not(.desc) .down {
  opacity: 0.3;
}
.mat-mdc-cell {
  border-bottom: var(--table-cell-stroke-width, 1px) solid var(--classic-ui-1-opacity-6, rgba(0, 0, 0, 0.1));
}
.serial-number-content {
  display: flex;
}
.serial-number-content sh-text {
  width: max-content;
  text-decoration: underline;
}
.serial-number-content:hover sh-text {
  cursor: pointer;
  color: var(--text-highlight);
}
.advanced-search-content sh-icon {
  margin: 2px 4px;
}
.system-link {
  text-decoration: none;
  color: inherit;
  display: inline-flex;
  align-items: center;
}
.custom-sort-icon {
  display: flex;
  flex-direction: column;
  margin-left: 6px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  position: relative;
  align-items: center;
  gap: 1px;
}
.custom-sort-icon .arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  transition: opacity 0.2s ease;
}
.custom-sort-icon .up {
  border-bottom: 8px solid var(--text-primary, #000);
}
.custom-sort-icon .down {
  border-top: 8px solid var(--text-primary, #000);
}
.custom-sort-icon:not(.asc):not(.desc) .up,
.custom-sort-icon:not(.asc):not(.desc) .down {
  opacity: 0;
}
.custom-sort-icon:not(.asc):not(.desc):hover .up,
.custom-sort-icon:not(.asc):not(.desc):hover .down {
  opacity: 0.3;
}
.custom-sort-icon.asc,
.custom-sort-icon.desc {
  display: grid;
  place-items: center;
}
.custom-sort-icon.asc .arrow,
.custom-sort-icon.desc .arrow {
  grid-row: 1;
  grid-column: 1;
}
.custom-sort-icon.asc .up {
  opacity: 1;
}
.custom-sort-icon.asc .down {
  opacity: 0;
}
.custom-sort-icon.desc .up {
  opacity: 0;
}
.custom-sort-icon.desc .down {
  opacity: 1;
}
.advance-search-result-info-icon {
  position: absolute;
  top: 10px;
  left: 110px;
  display: flex;
  vertical-align: middle;
  margin-left: 5px;
  z-index: 2;
  cursor: pointer;
}
.advance-search-result-info-icon-message {
  overflow-wrap: normal;
  max-width: 320px;
  font-weight: 500;
}
/*# sourceMappingURL=advanced-search-table.component.css.map */
